import {
  MutableRefObject,
  RefCallback,
  useCallback,
  useMemo,
  useRef,
} from 'react'

type setNodeHeightType = (isVisible: boolean) => void

export type UseHeightTransitionType = ({
  getIsVisible,
  collapsedHeight,
}: {
  getIsVisible: () => boolean
  collapsedHeight?: number
}) => {
  setComponentRef: RefCallback<HTMLDivElement>
  setNodeHeight: setNodeHeightType
  wrapperRef: MutableRefObject<HTMLDivElement | undefined>
}

const useHeightTransition: UseHeightTransitionType = ({
  getIsVisible,
  collapsedHeight,
}) => {
  const wrapperRef = useRef<HTMLDivElement>()
  const expandedComponentHeight = useRef<number>(0)

  const setNodeHeight: setNodeHeightType = useCallback(
    (isVisible) => {
      if (wrapperRef.current) {
        wrapperRef.current.style.height = `${
          isVisible ? expandedComponentHeight.current : collapsedHeight || 0
        }px`
      }
    },
    [collapsedHeight]
  )

  const setComponentRef: RefCallback<HTMLDivElement> = useCallback(
    (node) => {
      if (node) {
        wrapperRef.current = node
        expandedComponentHeight.current = node.scrollHeight
        setNodeHeight(getIsVisible())
      }
    },
    [getIsVisible, setNodeHeight]
  )

  const heightTransitionFunctions = useMemo(
    () => ({ setComponentRef, setNodeHeight, wrapperRef }),
    [setComponentRef, setNodeHeight, wrapperRef]
  )

  return heightTransitionFunctions
}

export default useHeightTransition
